module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8d0ae2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/funcionario/editar.vue
// module id = 1496
// module chunks = 44